/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInventoryOutCommandResult } from '../../models/create-inventory-out-command-result';
import { ItemDetailsVm } from '../../models/item-details-vm';

export interface ApiNurseryManagerInventoryOutCreateInventoryOutPost$Params {
      body?: {
'Items'?: Array<ItemDetailsVm>;
'DeliveredDate'?: string;
'IsMobile'?: boolean;
'Signature'?: Blob;
}
}

export function apiNurseryManagerInventoryOutCreateInventoryOutPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryOutCreateInventoryOutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryOutCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryOutCreateInventoryOutPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateInventoryOutCommandResult>;
    })
  );
}

apiNurseryManagerInventoryOutCreateInventoryOutPost.PATH = '/api/NurseryManager/InventoryOut/CreateInventoryOut';
